import {Box, merge, type SxProp} from '@primer/react'
import type {PropsWithChildren} from 'react'
import type {BetterSystemStyleObject} from '@primer/react/lib-esm/sx'
import {testIdProps} from '@github-ui/test-id-props'

const containerStyles: BetterSystemStyleObject = {
  display: 'flex',
  flexWrap: 'nowrap',
  gap: 1,
  color: 'fg.muted',
  fontWeight: 'normal',
  fontSize: 0,
  alignItems: 'center',
}

type DescriptionProps = PropsWithChildren<SxProp>

function Description({children, sx: externalSx}: DescriptionProps) {
  const sx = externalSx ? merge<BetterSystemStyleObject>(containerStyles, externalSx) : containerStyles
  return (
    <Box {...testIdProps('list-view-item-description')} sx={sx}>
      {children}
    </Box>
  )
}

Description.displayName = 'ListItem.Description'

export {Description}
